import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ActivatedRoute, Router } from '@angular/router';
import { SupplierService } from '../../features/suppliers/services/suppliers.service';

@Component({
  selector: 'app-supplier-new',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
  ],
  templateUrl: './supplier-new.component.html',
  styleUrl: './supplier-new.component.scss',
})
export class SupplierNewComponent {
  newSupplierForm: FormGroup;
  loading: boolean = false;
  supplierId: any = null;
  supplierData: any;

  constructor(
      private fb: FormBuilder,
      private toastr: ToastrService,
      private supplierService: SupplierService,
      private route: Router,
      private router: ActivatedRoute
    ) {}

  ngOnInit() {
    this.initForm();
    this.router.paramMap.subscribe((params) => {
      this.supplierId = params.get('id');
      if(this.supplierId){
        this.fetchSupplierById(Number(this.supplierId));
      }
      else{
        this.getSupplierCode()
      }
    });
  }

  initForm() {
    this.newSupplierForm = this.fb.group({
      code: [
        { value: '', disabled: true },
        [Validators.required, Validators.maxLength(50)],
      ],
      name: ['', [Validators.required, Validators.maxLength(50)]],
      contactNumber: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(15),
          Validators.pattern('^[0-9]+$'),
        ],
      ],
      address: [''],
    });
  }

  fetchSupplierById(id: any) {
    this.supplierService.fetchSingleSupplier(id).subscribe({
      next: (data) => {
        this.supplierData = data;
        this.newSupplierForm.patchValue({
          name: this.supplierData?.supplierName,
          address: this.supplierData?.address,
          contactNumber: this.supplierData?.contact,
          code: this.supplierData?.supplierCode,
        });
      },
      error: (error) => {
        console.error(error, 'Error');
      },
    });
  }


  onCancel() {
    this.newSupplierForm.reset();
    this.route.navigate(['/suppliers']);
  }

  async onSubmit() {
    this.loading = true;

    if (this.newSupplierForm.invalid) {
      this.newSupplierForm.markAllAsTouched();
      this.loading = false;
      return;
    }
    // const formValue = this.newSupplierForm.value;
    const formValue = this.newSupplierForm.getRawValue();
    const createSupplierValue = {
      supplierName: formValue?.name,
      address: formValue?.address,
      contact: formValue?.contactNumber,
      supplierCode: formValue?.code,
    };

    if (!this.supplierId) {
      this.supplierService.createSupplier(createSupplierValue).subscribe({
        next: (data) => {
          this.loading = false;
          this.toastr.success('Supplier created successfully', 'Success');
          this.route.navigate(['/suppliers']);
        },
        error: (error) => {
          this.loading = false;
          this.toastr.error(error, 'Error');
        },
      });
    } else {
      const updateSupplierValue = {
        id: Number(this.supplierId),
        ...createSupplierValue,
      };
      this.supplierService.updateSupplier(updateSupplierValue).subscribe({
        next: (data) => {
          this.loading = false;
          this.toastr.success('Supplier updated successfully', 'Success');
          this.route.navigate(['/suppliers']);
        },
        error: (error) => {
          this.loading = false;
          this.toastr.error(error, 'Error');
        },
      });
    }
  }

  getSupplierCode() {
    this.supplierService.fetchSupplierCode().subscribe({
      next: (code) => {
        if (code) {
          this.newSupplierForm.patchValue({ code });
        }
      },
      error: (error) => {
        console.error('Error fetching stationary code:', error);
      },
    });
  }
}
